import { CommonModule } from "@angular/common";
import { Component, OnInit, Input, Output, AfterViewInit } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ethers } from "ethers";
import { firstValueFrom, forkJoin } from "rxjs";
import { CreatureLiteWebDto } from "../../../../dtos/creature.lite.web.dto";
import { CreatureWebDto } from "../../../../dtos/creature.web.dto";
import { CreaturesService } from "../../../../services/creatures.service";
import { Web3WalletService } from "../../../../services/web3-wallet.service";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";


var window: Window & { ethereum: any } = globalThis as any;

@Component({
    selector: 'continue-breeding-page',
    templateUrl: './continue-breeding.page.html',
    styleUrl: './continue-breeding.page.scss',
    imports: [
        CommonModule,
        RouterLink,
        TranslateModule
    ]
})
export class ContinueBreedingPage implements AfterViewInit {

    public lang: string | null = null;
    public creatureRef: CreatureWebDto | null = null;
    public selectedCreature: CreatureWebDto | null = null;

    constructor(
        private readonly web3WalletService: Web3WalletService,
        private readonly creaturesService: CreaturesService,
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly translateService: TranslateService
    ) {

    }

    private breedingOrderId: number | null = null;
    async ngAfterViewInit(): Promise<void> {
        this.lang = this.translateService.currentLang;
        this.translateService.onLangChange.subscribe((event) => {
            this.lang = event.lang;
        })

        const creature1Id = this.route.snapshot.paramMap.get('creature-1-id');
        const creature2Id = this.route.snapshot.paramMap.get('creature-2-id');
        const breedingOrderId = this.route.snapshot.paramMap.get('breeding-order-id');
        if (!creature1Id || !creature2Id || !breedingOrderId) {
            throw new Error('Invalid parameters for continue breeding');
        }
        let tasks1 = this.creaturesService.getById(creature1Id).toPromise();

        let tasks2 = this.creaturesService.getById(creature2Id).toPromise();

        const res = await firstValueFrom(forkJoin([tasks1, tasks2]));

        this.creatureRef = res[0]!;
        this.selectedCreature = res[1]!;

        if (!this.creatureRef || !this.selectedCreature) {
            throw new Error('Creature not found');
        }

        this.breedingOrderId = parseInt(breedingOrderId);
        this.showLoading = false;
    }

    public async onSelectCreature(creature: CreatureLiteWebDto | any) {
        this.selectedCreature = creature;
        // this.showBreedingListPopup = false;
        // this.selectedCreatureAbilityToBreed = await this.checkAbilityToBreed(creature.nftTokenId!);
    }

    async checkAbilityToBreed(tokenId: number): Promise<boolean> {
        const contract: any = await this.web3WalletService.getBreedingContract();
        const result = await contract.checkAbilityToBreed(tokenId);
        return result;
    }

    public showLoading: boolean = true;
    public async onBreed() {

        this.showLoading = true;

        let logs = [];

        try {

            const myAddress = this.web3WalletService.getWalletAddress()!;
            logs.push('MyAddress: ' + myAddress);

            const creature1Id = this.creatureRef!.nftTokenId!;
            logs.push('Creature1Id: ' + creature1Id);
            const creature2Id = this.selectedCreature!.nftTokenId!;
            logs.push('Creature2Id: ' + creature2Id);

            // const nftContract: any = await this.web3WalletService.getNftContract();
            // const ownerOfCreature1Address = await nftContract.ownerOf(creature1Id);
            // logs.push('Owner of creature 1 Address: ' + ownerOfCreature1Address);
            // const ownerOfCreature2Address = await nftContract.ownerOf(creature2Id);
            // logs.push('Owner of creature 2 Address: ' + ownerOfCreature2Address);

            // if (ownerOfCreature1Address.toLowerCase() !== myAddress.toLowerCase()) {
            //     throw new Error("You don't own creature 1");
            // }

            // if (ownerOfCreature2Address.toLowerCase() !== myAddress.toLowerCase()) {
            //     throw new Error("You don't own creature 2");
            // }

            const signer = await this.web3WalletService.getSigner();
            const contract: any = await this.web3WalletService.getBreedingContract();

            const feeData = await this.web3WalletService.getFeeData();
            const gasPriceInWei = ethers.formatUnits(feeData.gasPrice!, 'wei');

            // logs.push('Contract Address: ' + contract.target);

            // const result = await contract.checkAbilityToBreed(creature1Id);
            // logs.push('Check ability to breed creature 1: ' + result);

            // const result2 = await contract.checkAbilityToBreed(creature2Id);
            // logs.push('Check ability to breed creature 2: ' + result2);

            // const getNotFungibleTokenAddr = await contract.getFunction("getNotFungibleTokenAddr");
            // const notFungibleTokenAddress = await getNotFungibleTokenAddr.staticCall();
            // logs.push('NotFungibleTokenAddress: ' + notFungibleTokenAddress);

            // const paymentTokenAddr = await contract.getFunction("getPaymentTokenAddr");
            // const paymentTokenAddress = await paymentTokenAddr.staticCall();
            // logs.push('PaymentTokenAddress: ' + paymentTokenAddress);

            // const rarities: number[] = [
            //     this.creatureRef.rarity,
            //     this.selectedCreature!.rarity
            // ];
            // const getBreedingFeeByRarities = await contract.getFunction("getBreedingFeeByRarities");
            // const fee = await getBreedingFeeByRarities.staticCall(rarities);
            // logs.push('Breeding Fee: ' + fee);

            // const paymentTokenContract: any = new ethers.Contract(paymentTokenAddress, [
            //     "function approve(address spender, uint256 amount) public returns (bool)",
            //     "function allowance(address owner, address spender) public view returns (uint256)"
            // ], signer);
            // const paymentTokenAllowance = await paymentTokenContract.allowance(myAddress, contract.target);

            // logs.push('PaymentTokenContract: Payment token allowance: ' + paymentTokenAllowance.toString());
            // if (paymentTokenAllowance < fee) {
            //     const paymentTokenApproveTx = await paymentTokenContract.approve(contract.target, fee);
            //     const paymentTokenApproveReceipt = await paymentTokenApproveTx.wait();
            //     const hash = paymentTokenApproveReceipt.hash;
            //     logs.push('PaymentTokenContract: Payment token approval transaction hash: ' + hash);
            // } else {
            //     logs.push('PaymentTokenContract: Payment token already approved');
            // }

            // const isApproved = await nftContract.isApprovedForAll(myAddress, contract.target);
            // if (!isApproved) {
            //     const estimatedGas = await nftContract.setApprovalForAll.estimateGas(
            //         contract.target,
            //         true,
            //         {
            //             from: myAddress
            //         }
            //     );
            //     const approvalForAllTx = await nftContract.setApprovalForAll(contract.target, true, {
            //         gasLimit: estimatedGas,
            //         gasPrice: gasPriceInWei,
            //     });
            //     const approvalForAllReceipt = await approvalForAllTx.wait();
            //     const hash = approvalForAllReceipt.hash;
            //     logs.push('NftContract: setApprovalForAll transaction hash: ' + hash);
            // } else {
            //     logs.push('NftContract: setApprovalForAll already approved');
            // }

            // const estimatedGas = await contract.createBreedingOrder.estimateGas(
            //     creature1Id,
            //     creature2Id,
            //     {
            //         from: myAddress
            //     }
            // );
            // const createBreedingOrderTx = await contract.createBreedingOrder(creature1Id, creature2Id, {
            //     gasLimit: estimatedGas,
            //     gasPrice: gasPriceInWei,
            // });
            // const createBreedingOrderReceipt = await createBreedingOrderTx.wait();
            // const createBreedingOrderHash = createBreedingOrderReceipt.hash;

            // logs.push('Breeding Order transaction hash: ' + createBreedingOrderHash);


            // for (const log of createBreedingOrderReceipt.logs) {
            //     if (log.address.toLowerCase() !== contract.target.toLowerCase()) continue;
            //     try {
            //         const event = contract.interface.parseLog(log);
            //         if (event && event.name === "OrderIsCreated") {
            //             orderId = parseInt(event.args.orderId.toString());
            //             break;
            //         }
            //     } catch (e) {
            //         // not the right event, skip
            //     }
            // }

            // logs.push('Parsed orderId: ' + orderId);


            const checkReadyToHatchFn = await contract.getFunction('checkReadyToHatch');
            const isReadyToHatch = await checkReadyToHatchFn.staticCall(this.breedingOrderId);
            if (!isReadyToHatch) {
                logs.push('Breeding is not ready to hatch yet. OrderId: ' + this.breedingOrderId);
                return;
            }
            const createCreatureEstimatedGas = await contract.createCreature.estimateGas(
                this.breedingOrderId,
                {
                    from: myAddress
                }
            );

            const createCreatureTx = await contract.createCreature(this.breedingOrderId, {
                gasLimit: createCreatureEstimatedGas,
                gasPrice: gasPriceInWei,
            });
            const createCreatureReceipt = await createCreatureTx.wait();
            const createCreatureHash = createCreatureReceipt.hash;

            logs.push('Breeding Create Creature transaction hash: ' + createCreatureHash);

            const task1 = this.creaturesService.сheckAbilityToBreedById(this.creatureRef!.id);
            const task2 = this.creaturesService.сheckAbilityToBreedById(this.selectedCreature!.id);

            const [res1, res2] = await firstValueFrom(forkJoin([task1, task2]));
            this.showLoading = false;

            this.router.navigate([this.lang, 'my-creatures', 'view', this.creatureRef!.id]);


        } catch (error) {
            logs.push('Error: ' + JSON.stringify(error));
            console.error('Error executing breeding function:', error);
            this.showLoading = false;
        } finally {

        }
    }
}
